import { ValueOf } from './util';

/** 付与タイミングのenum */
export const EUseStartPattern = {
  IMMEDIATE: '即時',
  DAYS_LATER: '指定',
} as const;

export type UseStartPatternKey = keyof typeof EUseStartPattern;
export type UseStartPatternValue = ValueOf<typeof EUseStartPattern>;

export const useStartPatternKeys = Object.keys(EUseStartPattern) as (UseStartPatternKey[]);

/** v-select用items */
export const useStartPatternItems = useStartPatternKeys
  .map((key) => ({
    title: EUseStartPattern[key],
    value: key,
  }));
